// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"deef7f46","551":"205e7d3c","640":"5e9ec099","828":"f3f31c14","864":"dc071c03"}[chunkId] + ".chunk.js";
};